/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import can from 'can';
import $ from 'jquery';
import BaseControl from 'scripts/base-control';
import dtm from 'scripts/services/dtm';
import statsDataView from './mini-player-stats.stache';
import statsSelectorView from './mini-player-stats-selector.stache';
import _ from 'lodash';

const filters = [
    {
        'type': 'drives',
        'title': 'Driving distance',
        'availableColumns': [
            {
                'type': 'rank',
                'title': 'rank'
            },
            {
                'type': 'pos',
                'title': 'pos'
            },
            {
                'type': 'name',
                'title': 'player'
            },
            {
                'type': 'avg',
                'title': 'avg'
            }
        ],
        'players': []
    },
    {
        'type': 'aces',
        'title': 'Eagles and aces',
        'availableColumns': [
            {
                'type': 'name',
                'title': 'player'
            },
            {
                'type': 'round',
                'title': 'round'
            },
            {
                'type': 'hole',
                'title': 'hole'
            },
            {
                'type': 'eagle-or-ace',
                'title': 'eagle or ace'
            }
        ],
        'players': []
    },
    {
        'type': 'fairways',
        'title': 'Fairways Hit',
        'availableColumns': [
            {
                'type': 'rank',
                'title': 'rank'
            },
            {
                'type': 'pos',
                'title': 'pos'
            },
            {
                'type': 'name',
                'title': 'player'
            },
            {
                'type': 'avg',
                'title': 'avg'
            }
        ],
        'players': []
    },
    {
        'type': 'gir',
        'title': 'Greens in regulation',
        'availableColumns': [
            {
                'type': 'rank',
                'title': 'rank'
            },
            {
                'type': 'pos',
                'title': 'pos'
            },
            {
                'type': 'name',
                'title': 'player'
            },
            {
                'type': 'avg',
                'title': 'avg'
            }
        ],
        'players': []
    },
    {
        'type': 'putts',
        'title': 'Putts',
        'availableColumns': [
            {
                'type': 'rank',
                'title': 'rank'
            },
            {
                'type': 'pos',
                'title': 'pos'
            },
            {
                'type': 'name',
                'title': 'player'
            },
            {
                'type': 'avg',
                'title': 'avg'
            }
        ],
        'players': []
    }
];

const defaultFilter = {
    'type': 'drives',
    'title': 'Driving distance'
};

const updateInterval = 45 * 1000;

export const RightRailMiniPlayerStats = BaseControl.extend({
    init: function () {
        this._super();

        this.$selector = this.$element.find('.js-filter-selector-container');
        this.$content = this.$element.find('.js-content');

        this.$selector
            .html(statsSelectorView({
                availableFilters: filters,
                defaultFilter: defaultFilter
            }));

        this.getData();
        setInterval(this.getData.bind(this), updateInterval);
    },

    getData() {
        const urls = filters.map(filter => _.get(this.options[filter.type], '')).filter(url => !!url);
        this.filters = [];

        filters.map((filter) => {
            const url = _.get(this.options, filter.type, '');

            can.ajax({
                type: 'GET',
                url,
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then((result) => {
                const allPlayers = filter.type === 'aces' ?
                    _.get(result, 'event.tournament.highlight', []) :
                    _.get(result, 'event.tournament.players.player', []);
                const players = allPlayers
                    .map(player => Object.assign({}, player, { name: this.getPlayerName(player.name) }))
                    .slice(0, 5);
                this.filters.push(
                    Object.assign({}, filter, { players })
                );

                const currentFilter = this.$selectedFilter.data('filter') || defaultFilter.type;

                if (filter.type === currentFilter) {
                    this.displayStats(filter.type);
                }
            });
        });

        this.$currentFilterContainer = this.$element.find('.js-current-filter');
        this.$selectedFilter = this.$element.find('.js-item.is-selected');
    },

    getPlayerName(name) {
        const tags = name.trim().split('  ');
        const isAmateur = !!tags[1] ? ' (a)' : '';
        const fullName = tags[0].split(',').reverse().map(name => name.trim());

        return `${fullName[0]} ${fullName.slice(1).join(' ')}${isAmateur}`;
    },

    displayStats: function (filterType) {
        const stats = this.filters.find(item => item.type === filterType);

        this.$content
            .html(statsDataView({
                stats,
                filter: filterType
            }));
    },

    '.js-filter-selector-container click': function (el) {
        $(el.context).toggleClass('is-expanded')
    },

    '.js-item click': function (el) {
        const target = $(el.context);
        const targetFilter = target.data('filter');
        this.$selectedFilter.removeClass('is-selected');
        this.$selectedFilter = target.addClass('is-selected');
        this.$currentFilterContainer.html(filters.find(filter => filter.type === targetFilter).title);
        this.displayStats(targetFilter);
        dtm.trackRightRailDropdownSelection('RightRailMiniPlayerStats');
    },

    '.s-btn click': function (el) {
        dtm.trackRightRailLinkToFullClick('RightRailMiniPlayerStats');
    }
});
